import { IStore } from "@/redux/defaultStore";
import {ModalHeader, ModalBody} from "@/widgets/ModalParts";
import classNames from "classnames";
import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {Modal} from "@/widgets/Modal";
import { isMobile } from "react-device-detect";
import useThemePreference from "@/hooks/useThemePreference";
import {Button} from "@/components/buttons/Button";
import { updateIsIndustryDismissedForSession } from "@/redux/meta/metaActions";

interface props {
    isVisible: boolean;
    onClose: () => void;
}

export const InvitedWelcomeModal: FC<props> = ({ isVisible, onClose }) => {
    const isOnOverwolf = useSelector((store: IStore) => store.metaStore.isOnOverwolf);
    const dispatch = useDispatch();
    const { isOnDarkMode } = useThemePreference();
    useEffect(() => {
        dispatch(updateIsIndustryDismissedForSession(true));
    }, []);
    return (
        <Modal
            contentClassName={classNames("invited-welcome-modal")}
            containerClassName="invited-welcome-modal-container"
            size={"sm2"}
            isOpen={isVisible}
            // toggle={onClose} Accidental closing the login modal will require the user to get a new code and invalid their previous one
        >
            <>
                <div
                    className="invite-modal_background"
                    style={{
                        backgroundImage: `url(${`${import.meta.env.VITE_CDN_URL}/images/referral-modal-${
                            isMobile ? "sm" : "lg"
                        }.webp`})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "8.73556rem",
                    }}
                ></div>
                <div
                    className="invite-modal_shader"
                    style={{
                        background: `linear-gradient(180deg, rgba(45, 45, 47, 0.10) 0%, ${
                            isOnDarkMode ? "#2D2D2F" : "white"
                        } 8rem)`,
                    }}
                ></div>
            </>
            <ModalHeader toggle={onClose}>
                {isOnOverwolf
                    ? <img
                        src={`${import.meta.env.VITE_CDN_URL}/images/DevourPlayLogoWhite.webp`}
                        alt="Devour logo"
                        className="overwolf-landing-page_login-logo"
                    />
                    : <img src={`${import.meta.env.VITE_CDN_URL}/images/devour-logo-white.png`}
                        alt="Devour logo"
                        style={{
                            height: "auto",
                            width: "6rem",
                        }}/>
                }
            </ModalHeader>
            <ModalBody>
                <div className="invited-welcome-modal_body">
                    <div className="invited-welcome-modal_body_heading">
                        <h5>Welcome to Devour</h5>
                        <span>
                            You have unlocked $30 in savings thanks to your friend! Enjoy exclusive savings on your next
                            first orders.
                        </span>
                    </div>
                    <div className="invited-welcome-modal_body_content">
                        <img src={`${import.meta.env.VITE_CDN_URL}/images/lp-earn-discounts.webp`} alt="Discounts image" />
                        <h5>$10 OFF First 3 Orders</h5>
                    </div>
                    <Button variant="primary" onClick={onClose} to="/home#merchant-search">
                        Order Now
                    </Button>
                    <div className="invited-welcome-modal_body_footer">
                        <hr />
                        <p>
                            Your discount applies automatically on orders over $15 and can be used up to 3 times (max
                            $10 per order). The referral discount is non-transferable, cannot be combined with other
                            promotions, and is only valid for eligible users. Terms apply.
                        </p>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};
